<template>
  <div class="content-inner">
		<x-panel margin>
			<div slot="title">IP Access Controls</div>
			<div slot="extra" :class="`d-flex justify-content-end`">
					<el-input v-model="listFilters.search" placeholder="Search IP or Description... " clearable class="filter-item mr-2" @keyup.enter.native="handleFilter(true)" @clear="handleFilter(true)"/>
					<el-button v-waves type="primary" icon="el-icon-search" @click="handleFilter(true)">
							Search
					</el-button>
					<el-button type="success" icon="el-icon-plus" @click="handleCreate">
							Add
					</el-button>
			</div>
		</x-panel>
		<el-table
			:data="collection.data"
			style="width: 100%"
			v-loading="loading"
			fit
			ref="filterTable"
			row-key="id"
			border
			default-expand-all>
			<el-table-column
					prop="ip"
					label="IP Address">
			</el-table-column>
			<el-table-column
                    prop="action"
                    align="center"
					label="Action">
                    <template slot-scope="scope">
                        <el-tag size="mini" :type="scope.row.action ? 'success' : 'danger'">{{ scope.row.action ? 'Allow' : 'Deny' }}</el-tag>
                    </template>
			</el-table-column>
            <el-table-column
                    prop="expiration"
                    align="center"
					label="Expiration Date">
			</el-table-column>
            <el-table-column
                    prop="description"
                    header-align="center"
					label="Description">
			</el-table-column>
            <el-table-column
                    prop="type"
                    header-align="center"
					label="Type">
			</el-table-column>
            <el-table-column
                    align="center"
					label="Status">
                    <template slot-scope="scope">
                        <el-tag size="mini" :type="scope.row.deleted_at ? 'danger' : 'success'">{{ scope.row.deleted_at ? 'Deactivated' : 'Active' }}</el-tag>
                    </template>
			</el-table-column>
			<el-table-column label="Action" width="110" align="center">
                <template slot-scope="scope">
                    <el-dropdown class="w-100">
                        <el-button style="color: green" size="small" @click="handleActionButtonClick">
                            Action
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="handleEdit(scope.row)">
                                <span>Edit</span>
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="handleDeactivate(scope.row)" v-if="!scope.row.deleted_at">
                                <span>Deactivate</span>
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="handleActivate(scope.row)" v-if="scope.row.deleted_at">
                                <span>Activate</span>
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="handlePermenantDelete(scope.row)" v-if="scope.row.deleted_at">
                                <span>Remove</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
		</el-table>

		<pagination v-show="collection.total > 0" :total="collection.total" :page.sync="collection.current_page" :limit.sync="collection.per_page" @pagination="getCollection" />

		{{ /* Add IP */ }}
		<el-dialog :class="`merge-dialog`" title="Create Team" :visible.sync="modal.show" :modal="false" :key="entry.ip">
			<div slot="title">
				Blacklist/Whitelist IP<br>
                <small>Specify an IP and configure appropriate action</small>
			</div>
			<div class="row group-class">
				<div class="col-12 col-lg-6">
					<label for="ip-address">IP Address</label>
					<ip-input class="mb-3" name="ip-address" v-model="entry.ip"></ip-input>
				</div>

                <div class="col-12" :class="entry.type === '2fa' ? 'col-lg-6' : 'col-lg-3'">
					<label for="action">Type</label>
					<el-select name="action" v-model="entry.type" placeholder="Select" class="w-100">
                        <el-option
                        v-for="item in typeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
				</div>

                <div class="col-12 col-lg-3" v-if="entry.type !== '2fa'">
					<label for="action">Action</label>
					<el-select name="action" v-model="entry.action" placeholder="Select" class="w-100">
                        <el-option
                        v-for="item in actionOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
				</div>
                <div class="col-12 pb-3" v-if="entry.type === '2fa'">
                    <el-alert
                        title="Adding this IP will set the 2FA request frequency to the global default of 30 days when users are logging in from this location, all other locations will use the frequency set in the tenant configuration."
                        :closable="false"
                        type="success">
                    </el-alert>
                </div>
				<div class="col-12 col-lg-6">
					<label for="expiration">Expiration <small>(optional)</small></label>
                    <el-date-picker
                        name="expiration"
                        v-model="entry.expiration"
                        type="date"
                        class="w-100"
                        placeholder="Pick an expiration">
                    </el-date-picker>
				</div>

				<div class="col-12 col-lg-6">
					<label for="description">Description</label>
					<el-input class="mb-3" name="description" v-model="entry.description"></el-input>
				</div>

			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleReset()">Cancel</el-button>
				<el-button type="success" @click="handleSubmit()">Submit</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
import Pagination from '@shared/components/pagination'
import ipInput from './IpInput'
import axios from 'axios'
export default {
  name: 'IpBlacklist',
  components: { Pagination, ipInput },
  props: {
  },
  data() {
    return {
			collection: {},
			search: '',
			loading: true,
			listFilters:{
					search: '',
			},
			listLimit: 10,
            actionOptions: [
                {
                    value: 0,
                    label: 'Deny'
                }, {
                    value: 1,
                    label: 'Allow'
                }
            ],
            typeOptions: [
                {
                    value: 'access',
                    label: 'Access'
                }, {
                    value: '2fa',
                    label: '2FA'
                }
            ],
			modal: {
				show: false,
                action: ''
			},
			entry: {
                ip: '',
                action: 0,
                type: 'access',
                expiration: '',
                description: ''
            },
        selected: {},
    }
  },
  computed: {
  },
  watch: {
  },
  mounted() {
		this.$tenant.get(`/api/settings/ip-blacklist`)
			.then((res) => {
				this.setData(res, 'collection')
			}).catch(err => {
              err.output()
            })

  },
  updated() {
  },
  activated() {
  },
  methods: {
		setData(res, model) {
			this.$set(this.$data, model, res.data.collection)
			this.loading = false;
			this.$bar.finish()
		},
		clearFilter() {
			this.$refs.filterTable.clearFilter();
		},
		handleFilter(loading = false){
            this.loading = loading;
            let collection = this.collection;
            let event = {
                page: 1,
                limit: collection.per_page
            }
            this.getCollection(event);
		},
        handleCreate() {
			this.modal.show = true;
            this.modal.action = 'create';
		},
        handleSubmit(){
            if (this.modal.action == 'create') {
                this.create();
            } else if (this.modal.action == 'edit') {
                this.edit();
            }
        },
		create() {
			this.$tenant.post(`/api/settings/ip-blacklist/create`,
                {
                    ...this.entry,
                    action: this.entry.type == '2fa' ? 1 : this.entry.action,
                })
			.then((res) => {
				this.handleFilter()
				this.handleReset();
			}).catch(err => {
              err.output()
          })
		},
		handleReset() {
			let entry = {
                ip: '',
                action: 0,
                type: 'access',
                expiration: '',
                description: ''
            }
            this.modal.show = false;
			this.entry = entry;
		},
		handleEdit(row, id) {
            let entry = {
                id: row.id,
                ip: row.ip,
                action: row.action,
                type: row.type,
                expiration: row.expiration,
                description: row.description
            }
			this.entry = entry;
            this.modal.action = 'edit';
			this.modal.show = true;
		},
		edit() {
			this.$tenant.post(`/api/settings/ip-blacklist/${this.entry.id}/update`,
            {
                ...this.entry,
                action: this.entry.type == '2fa' ? 1 : this.entry.action
            })
			.then((res) => {
				this.handleFilter()
				this.handleReset();
			}).catch(err => {
              err.output()
          })
		},
		handleActivate(row) {
			this.$tenant.get(`/api/settings/ip-blacklist/${row.id}/activate`)
			.then((res) => {
				this.handleFilter();
			}).catch(err => {
                err.output()
            })
		},
		handleDeactivate(row) {
			this.selected = row;
			this.delete(row.id);
		},
		delete(id) {
			this.$tenant.get(`/api/settings/ip-blacklist/${id}/delete`)
			.then((res) => {
				this.handleFilter();
				this.selected = {};
			}).catch(err => {
                err.output()
            })
		},
		handlePermenantDelete(row) {
			this.$confirm('Are you sure to permanently delete this ip?')
				.then(() => {
					this.$tenant.get(`/api/settings/ip-blacklist/${row.id}/permenant-delete`)
					.then((res) => {
						this.handleFilter();
						this.selected = {};
					})
				})
				.catch(err => {
                    err.output()
                })
		},
		getCollection(event) {
			this.$bar.start()
			this.$tenant.get(`/api/settings/ip-blacklist?page=${event.page}&per_page=${event.limit}&${this.$serialize(this.listFilters)}`)
				.then (res => {
						this.$set(this.$data, 'collection', res.data.collection)
						this.loading = false;
						this.$bar.finish()
				}).catch(err => {
                    err.output()
                })
		},
        handleActionButtonClick(e) {
            e.stopPropagation()
        }
  }
}
</script>

<style lang="scss">
// @import '@assets/sass/backend/_core-variables.scss';
.logo-box {
	position: relative;
	min-height: 120px;

	.action {
		position: absolute;
    right: 10px;
    bottom: 10px;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    background: #bababa;
    text-align: center;
    font-size: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
	}
}

.team-manage {
	h4 {
		margin-bottom: 1rem!important;
	}
}

</style>
